import { styled } from '@modules/common/components/ThemeProvider/utils';

const WidgetHeader = styled('h3')``;

export default WidgetHeader;
